import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Cookies from 'js-cookie';
import { FormWrap, Input, Button, toast, analyticsHelpers } from 'day8-ui';
import { submitPromoCode } from '../actions/booking';

class PromoCode extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      code: Cookies.get('tyw_affiliate_code') || '',
      submitting: false
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async handleSubmit(e) {
    try {
      e.preventDefault();
      this.setState({ submitting: true });
      const { code } = this.state;
      const { booking } = this.props;
      const response = await this.props.submitPromoCode(booking.id, code);
      if (response.status === 'success') {
        this.setState({
          submitting: false
        });
        analyticsHelpers.applyPromoCode({ promoCode: code });
        // The server distinguishes a referral code from a plain promo code, so it supplies the
        // wording; the fallback is only for a response that somehow carries no message.
        toast.success(response.message || 'Promo code applied');
      } else {
        this.setState({
          submitting: false
        });
        toast.error(response.message);
      }
    } catch (e) {
      console.error(e);
      toast.error("Something went wrong... Please try again later");
    }
  }

  render() {
    const {
      code, submitting
    } = this.state;
    const { GA4_TRIGGERS } = analyticsHelpers;
    return (
      <FormWrap id={GA4_TRIGGERS.PROMOCODE_FORM_ID} onSubmit={submitting ? () => {} : this.handleSubmit} loading={submitting}>
        <div className="dui-flex dui-items-center dui-w-full dui-gap-4">
          <Input id="promo-code-field" className="dui-w-full" onChange={e => this.setState({ code: e.target.value })} placeholder="Referral code" value={code} />
          <Button className='dui-shrink-0' type="submit" disabled={submitting}>Apply code</Button>
        </div>
      </FormWrap>
    );
  }
}

PromoCode.propTypes = {
  submitPromoCode: PropTypes.func.isRequired,
  booking: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      submitPromoCode
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(PromoCode);
